import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from './../components/Sidebar';
import Adminheader from './../components/Adminheader';
import "../App.css"

const AdminLayout = () => {
  return (
    <div className="admin-layout-wrapper">

      <Adminheader />

      <div className="admin-container d-flex">
        <Sidebar />
        <div className="flex-grow-1 p-3 admin-content">
          <Outlet />
        </div>
      </div>

    </div>
  );
};

export default AdminLayout;
